import { UnderConstructionComponent } from "../../../components";

export const SettingIdentificationIndexPage = () => {
  return (
    <div>
      <UnderConstructionComponent />
    </div>
  );
};
